import { queryOptions } from '@tanstack/react-query';

import { PRODUCT_QUERY_KEYS } from '@/entities/product/keys';
import type { IProductOptions } from '@/entities/product/types';

import apiGetProduct from '../apis/get_product';

export const productOptions = ({ idx, lng }: IProductOptions) =>
  queryOptions({
    queryKey: [PRODUCT_QUERY_KEYS.GET_PRODUCT, idx, lng],
    queryFn: () => apiGetProduct({ idx, lng }),
    retry: false,
    enabled: !!idx && !!lng,
  });
